<ng-container *ngrxLet="{ value: value$, isCustomChipsDisabled: isCustomChipsDisabled$ } as vm">
    <dtm-ui-form-field
        [class.empty]="vm.value.length === 0"
        [isDisabled]="isDisabled$ | ngrxPush"
        [isActivated]="isActivated"
        *ngrxLet="isActivated$; let isActivated"
        matAutocompleteOrigin
        #autocompleteOrigin="matAutocompleteOrigin"
    >
        <ng-content select="label" ngProjectAs="label"></ng-content>
        <div *ngIf="vm.isCustomChipsDisabled" class="chips-selector-container" [class.empty]="!vm.value.length">
            <mat-chip *ngFor="let value of vm.value" (removed)="removeChip(value)">
                {{ value.label }}
                <button matChipRemove type="button" *ngIf="value.isRemovable !== false">
                    <dtm-ui-icon name="close-circle-fill" />
                </button>
            </mat-chip>
            <input
                #chipsInput
                [placeholder]="(placeholder$ | ngrxPush) ?? ''"
                [formControl]="customChipFormControl"
                [matAutocomplete]="auto"
                [matAutocompleteConnectedTo]="autocompleteOrigin"
            />
        </div>
        <mat-chip-grid *ngIf="!vm.isCustomChipsDisabled" #chipList>
            <mat-chip-row *ngFor="let value of vm.value" (removed)="removeChip(value)" [removable]="value.isRemovable !== false">
                {{ value.label }}
                <button matChipRemove type="button" *ngIf="value.isRemovable !== false">
                    <dtm-ui-icon name="close-circle-fill" />
                </button>
            </mat-chip-row>
            <input
                #chipsInput
                [placeholder]="(placeholder$ | ngrxPush) ?? ''"
                [formControl]="customChipFormControl"
                [matAutocomplete]="auto"
                [matAutocompleteConnectedTo]="autocompleteOrigin"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addCustomChip($event)"
            />
        </mat-chip-grid>
        <mat-autocomplete class="options-list" #auto="matAutocomplete" (optionSelected)="selectChip($event)">
            <mat-option *ngFor="let option of filteredOptions$ | ngrxPush" [value]="option" [disabled]="option.isDisabled">
                {{ option.label }}
            </mat-option>
        </mat-autocomplete>
        <ng-content select=".field-hint" ngProjectAs=".field-hint"></ng-content>
        <ng-content select=".field-error" ngProjectAs=".field-error"></ng-content>
    </dtm-ui-form-field>
</ng-container>
